import React from 'react'


export default (props) =>
    <svg {...props} width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="34" height="34" rx="5" fill="#ECF3F6"/>
        <path d="M17 7.72742V26.2729" stroke="#A9D1E0" stroke-width="3"/>
        <path d="M26.2715 17.0002L7.72603 17.0002" stroke="#A9D1E0" stroke-width="3"/>
    </svg>
